import { render, staticRenderFns } from "./ListCategoryTag.vue?vue&type=template&id=72682685&scoped=true&"
import script from "./ListCategoryTag.vue?vue&type=script&lang=js&"
export * from "./ListCategoryTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72682685",
  null
  
)

export default component.exports